import { Transaction } from '@bz/wallet';

export const route = {
  info: {
    login: true,
  },
} satisfies RouteDefinition;

export default Transaction;
